const VOTE_LABELS = { Yes: 'Proceed', No: 'Deny', Abstain: 'Abstain' }

export default VOTE_LABELS
